import type { ColumnDef } from '@tanstack/vue-table'

import { h } from 'vue'
import { Refunds } from '../../tables/Refunds'
export const refundsColumns: ColumnDef<Refunds.ListItem>[] = [
  {
    accessorKey: 'payoutReason',
  },
  {
    accessorKey: 'amount',
  },
  {
    accessorKey: 'isAccepted',
  },
  {
    accessorKey: 'insertTime',
  },
  {
    // These actions will be gotten from the `actions` field in the schema.
    id: 'actions',
    cell: ({ row }) => {
      return h('div', {}, [])
    },
  },
]
